module.exports = __webpack_public_path__ + "assets/icn-star-white.2a955b13.svg";